"use client";

export default function Footer() {
  return (
    <footer className="bg-[#212121] text-white/70 py-12 border-t border-white/10">
      <div className="container mx-auto px-4 flex flex-col items-center gap-8">
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm">
          <a href="#teachers" className="text-white/70 hover:text-white transition-colors">
            For teachers and volunteers
          </a>
          <a href="#partners" className="text-white/70 hover:text-white transition-colors">
            For schools and partners
          </a>
          <a href="#support" className="text-white/70 hover:text-white transition-colors">
            Need help?
          </a>
        </div>

        <div className="w-full border-t border-white/10" />

        <div className="flex flex-col sm:flex-row items-center gap-4 text-center">
          <img
            src="https://www.injazalarab.org/_nuxt/img/logo.a19ce7d.png"
            alt="INJAZ Al-Arab Logo"
            className="h-8 object-contain brightness-0 invert opacity-50"
          />
          <span className="text-sm sm:border-l sm:border-white/20 sm:pl-4">
            © {new Date().getFullYear()} INJAZ Al-Arab. All rights reserved.
          </span>
        </div>
      </div>
      <div className="pt-6 text-center text-xs text-white/40">
        Powered by{" "}
        <a
          href="https://potential.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white/50 hover:text-white/80 transition-colors"
        >
          Potential.com
        </a>
      </div>
    </footer>
  );
}
